module.exports = __webpack_public_path__ + "static/media/tire-filter.ca1b937c.svg";